import basemapLayers from '@/services/map-services/basemap-options';
import { getters } from '@/store/modules/layer-details-map/getters';
import { actions } from '@/store/modules/layer-details-map/actions';
import { mutations } from '@/store/modules/layer-details-map/mutations';
import { createSelectionLayer } from '@/services/map-services/layers';
const state = {
    basemaps: basemapLayers,
    layer: undefined,
    ol: {
        home: {
            center: undefined,
            zoom: undefined,
        },
        map: undefined,
        view: undefined,
        selectionLayer: createSelectionLayer(),
        layers: [],
    },
};
export const DetailsMap = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
